import type { RouteObject } from "react-router";

import { ErrorPage } from "@/components/Error/ErrorPage";
import { canAccessAdminTickets, canAccessResidentTickets } from "@/components/ProjectSidebar/permissions";
import { RequireAuth } from "@/components/Routing/RequireAuth";
import { RolePage } from "@/components/Routing/RolePage";

import { TicketDetailsPage } from "./pages/details/TicketDetailsPage";
import { TicketListPage } from "./pages/list/TicketListPage";
import { ResidentTicketDetailsPage } from "./pages/resident-details/ResidentTicketDetailsPage";
import { ResidentTicketListPage } from "./pages/resident-list/ResidentTicketListPage";
import { ticketsRoutes } from "./routes";

export const ticketsRoute = [
  {
    path: ticketsRoutes.list,
    element: (
      <RolePage
        getPageForRole={(role) => (
          <RequireAuth permission={role === "resident" ? canAccessResidentTickets : canAccessAdminTickets}>
            {role === "resident" ? <ResidentTicketListPage /> : <TicketListPage />}
          </RequireAuth>
        )}
      />
    ),
  },
  {
    path: ticketsRoutes.details,
    element: (
      <RolePage
        getPageForRole={(role) => (role === "resident" ? <ResidentTicketDetailsPage /> : <TicketDetailsPage />)}
      />
    ),
  },
  { path: "*", element: <ErrorPage status={404} /> },
] satisfies RouteObject[];
